import React, { useState, useEffect } from "react";
import { TextField, Button, Box, MenuItem, Select } from "@mui/material";
import style from "../../../../styles/gri/general.module.css";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DynamicStaticTable from "./DynamicTabeles";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import GRISidebar from "../../../../Layout/GRISidebar";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

function GRI306_3({ hide }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [tables, setTables] = useState([]);
  const [unit, setUnit] = useState("");
  const [total, setTotal] = useState(0);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({
    wasteDataContext: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "benifitProvided",
      //   title:

      type: "array",
      //   letter: "a.",
      fields: [
        {
          fieldName: "typeOfWaste",
          title: "Type of Waste",
          type: "text",
          placeholder: "Enter Text",
          width: "40%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "text",
        //   width: "30%",
        //   placeholder: "Enter Text",
        //   value: unit,
        // },
        {
          fieldName: "quantity",
          title: "Quantity",
          type: "number",
          width: "45%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const defaultSegments = [
    "Hazardous Waste",
    "Non-Hazardous Waste",
    "Electronic Waste",
    "Food Waste",
    "Biowaste",
  ];

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        const response = res?.data?.data?.GRI300?.wasteGenerated;
        setFormData({
          wasteDataContext: response?.wasteDataContext,
        });
        setTotal(response?.total?.value || 0); // Fallback to 0 if value is undefined
        setUnit(response?.total?.unit || ""); // Fallback to an empty string if unit is undefined
        setTables(
          response?.totalWasteGenerated.length > 0
            ? [{ rows: response?.totalWasteGenerated }]
            : inputData?.map((section) => ({
                fieldName: section?.fieldName,
                rows:
                  data?.[section?.fieldName]?.length > 0
                    ? data[section?.fieldName]
                    : defaultSegments.map((el) => ({ ["typeOfWaste"]: el })),
              }))
        ); // Fallback to an empty array if no data
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const updatedUnit = e.target.value; // Get the new unit value
    setUnit(updatedUnit);
    setTables((prev) =>
      prev.map((table) => ({
        ...table, // Spread the existing table object
        rows: table?.rows?.map((row) => ({
          ...row, // Spread each row object
          unit: updatedUnit, // Update the `unit` field
        })),
      }))
    );
  };

  const handleSubmit = async () => {
    if (!disabled) {
      const dataToSend = {
        ...formData,
        total: {
          value: total,
          unit: unit,
        },
        totalWasteGenerated: tables[0]?.rows,
      };
      try {
        await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          wasteGenerated: { ...dataToSend },
          submitted306_3: true,
        })
          .then((res) => navigate(`/gri/gri300/306-4/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/306-4/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && <p className={style.section_heading}>306 : Waste</p>}

      <p
        className={style.main_heading}
        style={{
          // marginTop: "2.5rem",

          marginBottom: hide ? "-1rem" : "0.5rem",
        }}
      >
        306-3: WASTE GENERATED
      </p>
      <p
        className={style.ques_heading}
        style={{
          // marginTop: "2.5rem",

          marginBottom: "0.5rem",
          display: "flex",
        }}
      >
        a. Provide the total weight of waste generated in metric tons, along
        with a breakdown of this total by the composition of the waste?
      </p>
      <Box sx={{ display: "flex", ml: 2 }}>
        <p className={style.ques_heading}>Unit</p>
        <Select
          sx={{
            height: "2rem",
            width: "24%",
            mt: "1rem",
            ml: "5px",
          }}
          name={`unit`}
          value={unit}
          placeholder="Select"
          onChange={(e) => handleChange(e)}
          displayEmpty
          size="small"
          disabled={disabled}

          //  fullWidth
          // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
        >
          <MenuItem value="">
            <em>Select</em>
          </MenuItem>
          {["Kg", "Tonns"].map((data, index) => (
            <MenuItem key={index} value={data}>
              {data}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <DynamicStaticTable
        {...{
          inputData,
          tables,
          setTables,
          unit,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments,
          parameter: "typeOfWaste",
          total,
          setTotal,
          disabled: disabled,
          hide: hide
        }}
      />
      <Box>
        <p
          className={style.ques_heading}
          style={{
            // marginTop: "2.5rem",
            marginRight: "1rem",
            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          b. Provide contextual information that is essential for understanding
          the data and detail how the data has been compiled.
        </p>
        <TextField
          placeholder="Enter Text"
          name="wasteDataContext"
          fullWidth
          sx={{ padding: " 0px 24px" }}
          value={formData?.wasteDataContext}
          onChange={(e) =>
            setFormData(
              // Keep previous values intact
              { wasteDataContext: e.target.value } // Update wasteDataContext with the new value
            )
          }
          disabled={disabled}
        />
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
}

export default GRI306_3;
